import { render, staticRenderFns } from "./WorkspaceSettings.vue?vue&type=template&id=7751cd6e&"
import script from "./WorkspaceSettings.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports